<template>
<div>
    <pageHead :title="title" :show-back="false" :btn-list="btnList" @handleBtn="handleBtn"></pageHead>
    <div class="content">
        <div class="search">
            <i-form ref="search" :model="query">
                <row :gutter="80">
                    <i-col span="6">
                        <form-item label="姓名" prop="name">
                            <Input v-model="query.name" clearable placeholder="请输入不动产单元号" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="身份证号" prop="idCardNO">
                            <Input v-model="query.idCardNO" clearable placeholder="请输入不动产单元号" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="合同号" prop="order_no">
                            <Input v-model="query.order_no" clearable placeholder="请输入不动产单元号" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="不动产单元号" prop="estate_unit_no">
                            <Input v-model="query.estate_unit_no" clearable placeholder="请输入不动产单元号" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="业务类型" prop="checkStatus">
                            <Select v-model="query.checkStatus" clearable>
                                <Option v-for="(item, index) in typeList" :key="index" :value="index" :label="item.name"></Option>
                            </Select>
                        </form-item>
                    </i-col>
                </row>
            </i-form>
        </div>
        <div class="table-data">
            <i-table :columns="tableHeader" :border="true" :loading="isLoading" :data="tableData" stripe ref="table" @on-row-dblclick="handleClickDetail1" @on-selection-change="handleSelect">
                <template slot-scope="{ row, index }" slot="attachment">
                    <a :href="`${row.attachment_url}`" target="_blank">{{row.attachment_name}}</a>
                </template>
                <template slot-scope="{ row, index }" slot="username">
                    <span style="margin-right: 10px;">{{row.user_name}}</span>
                    <Tag color="primary">{{row.user_type | userType}}</Tag>
                </template>
            </i-table>
            <div class="page">
                <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
contract
const {
    contract
} = api;

export default {
    name: "contract",
    components: {
        pageHead
    },
    filters: {
        userType: function (value) {
            let userType = ['卖方','购房人','共有人','抵押权人','借款人', '卖方共有人' , '办件人' ,'法院人员']
            return userType[value]
        }
    },
    data() {
        return {
            title: "不动产合同查询",
            btnList: [{
                    name: "重置",
                    type: "reset",
                },
                {
                    name: "搜索",
                    type: "search",
                }
            ],
            query: {
                name: "",
                idCardNO: "",
                order_no: "",
                checkStatus: "",
                estate_unit_no: ""
            },
            typeList: [{
                    name: '全部',
                    val: ''
                },
                {
                    name: '预购商品房预告登记',
                    val: 1,
                    type: "orderType"
                },
                {
                    name: '抵押权预告登记',
                    val: 3,
                    type: "orderType"
                },
                {
                    name: '新房办证',
                    val: 9,
                    type: "orderType"
                },
                {
                    name: '二手房过户',
                    val: 7,
                    type: "orderType"
                },
                {
                    name: '婚内变更',
                    val: "hnbg_pdf",
                    type: "attachmentType"
                },
                {
                    name: '离婚析产',
                    val: "lhxc_pdf",
                    type: "attachmentType"
                },
                {
                    name: '现房抵押',
                    val: 5,
                    type: "orderType"
                },
                {
                    name: '担保与抵押（反担保）',
                    val: 12,
                    type: "orderType"
                },
                {
                    name: '司法预查封',
                    val: "预查封",
                    type: "attachmentType"
                },
                {
                    name: '司法查封',
                    val: "查封",
                    type: "attachmentType"
                },
                {
                    name: '司法解封',
                    val: "解封",
                    type: "attachmentType"
                },
            ],
            tableData: [],
            isLoading: false,
            tableHeader: [{
                type: "selection",
                width: 70,
                align: "center",
            }, {
                title: "合同名称",
                slot: "attachment",
            }, {
                title: "合同号",
                key: "order_no",
            }, {
                title: "不动产单元号",
                key: "estate_unit_no",
            }, {
                title: "姓名",
                slot: "username",
            },{
                title: "时间",
                key: "create_time",
            }],
            pageNum: 1,
            pageSize: 10,
            total: 0,
        }
    },
    methods: {
        async loadData() {
            this.isLoading = true;

            let query = {
                userName: this.query.name || undefined,
                idCardNO: this.query.idCardNO || undefined,
                orderNo: this.query.order_no || undefined,
                estateUnitNo: this.query.estate_unit_no || undefined
            }

            let type = this.typeList[this.query.checkStatus]
            if(type && type.type){
                query[type.type] = type.val
            }

            try{
                let res = await this.$post(contract, {
                    apptype: "ipy",
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    ...query
                });

                this.tableData = res.rows;
                this.total = res.total;
            } finally {
                this.isLoading = false;
            }
        },
        handleBtn(btnType) {
            if(btnType == "reset"){
                this.pageNum = 1
                this.$refs.search.resetFields();
            } 

            this.loadData()
        },
        handleClickDetail1() {

        },
        handleSelect() {

        },
        pageChange(pageNum) {
            this.pageNum = pageNum
            this.loadData()
        }
    },
    created() {
        // this.loadData()
    },
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);

    .page {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .success {
        color: #ff7b44;
    }

    .action {
        color: #5e6d94;
        cursor: pointer;
        margin-right: 10px;
    }
}
</style>
